// add wishlist count
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(function () {
  var wishListCountDesk = document.getElementById("swym-wishlist-count-desktop");
  _swat.renderWishlistCount(wishListCountDesk);
   var wishListCountMob = document.getElementById("swym-wishlist-count-mobile");
  _swat.renderWishlistCount(wishListCountMob);
});

document.body.addEventListener('click', function (event) {
  if (event.target.matches('.swym-button')) {
    console.log("swym button clicked");
    event.target.classList.remove('swym-removing');
    event.target.classList.remove('swym-adding');
    event.target.classList.remove('disabled');
    if (event.target.matches('.swym-added')) {
      event.target.classList.remove('swym-added');
    } else {
      event.target.classList.add('swym-added');
    }
  }
});
